// src/features/services/components/ServiceBillingSection.tsx
import { EmptyState } from '../../../app/components/foundation';

/**
 * Billing section — future-ready presentation area. No billing/
 * transaction data exists on `Service` today, so this renders a
 * neutral placeholder instead of any fake transactions.
 */
export function ServiceBillingSection() {
  return <EmptyState message="اطلاعات صورتحساب این سرویس پس از یکپارچه‌سازی با Core Billing در دسترس خواهد بود." />;
}
